<template>
	<div class="container" v-show="showPage">
		<div class="logo"></div>
		<div class="language">
			<a href="cn/">简体中文</a>
			<a href="tw/">繁體中文</a>
		</div>
	</div>
</template>


<script>
	import {
		mixin
	} from '@/utils/mixin.js'
	export default {
		name: 'Home_Page',
		mixins: [mixin],
		data() {
			return {
				showPage: false,
			}
		},
		mounted() {
		},
		created() {
			if(this.isMobile())
			{
				window.location.href = 'https://m.hawaiiglobalholiday.com'
			}
			else
			{
				// this.showPage = true
				window.location.href = '/cn/'
			}
		},
		methods: {
		},
	}
</script>

<style lang="less" scoped>
	@import url("../assets/css/global.css");
	body {
		font-size: 13px;
	}
	.container {		
		width: 100vw;
		height: 100vh;
		padding-top: 20%;
		box-sizing: border-box;
		display: none;
		
		.logo {
			width: 250px;
			height: 80px;
			background-image: url(../assets/images/home_logo.png);
			background-repeat: no-repeat;
			background-position: center;
			background-size: 100% auto;
			margin: 0 auto;
		}
		
		.language {
			width: 288px;
			margin: 50px auto 0 auto;
			display: flex;
			
			a {
				width: 120px;
				height: 44px;
				line-height: 44px;
				text-align: center;
				background: #008768;
				color: #fff;
				border-radius: 22px;
				text-decoration: none;
				font-size: 16px;
				display: inline-block;
				vertical-align: middle;
				margin: 0 12px;
				-webkit-transition: all .5s ease;
				box-shadow: 1px 1px 5px #ccc;
			}
			
			a:hover {
				opacity: 1;
				background: #000;
				box-shadow: 1px 1px 5px #aaa;
			}
		}
	}
</style>